import { PlanungLookupAbo } from '@/types/service-response'

export class PlanningLookupAbo {
  private constructor (
    readonly id: number,
    readonly nummer: string | null,
    readonly titel: string | null,
    readonly adressNummer: string | null,
    readonly adressLinie: string | null,
    readonly label: string,
    readonly ihreReferenz: string | null
  ) {}

  public static createListFromResponse (data: PlanungLookupAbo[]): PlanningLookupAbo[] {
    return data.map((item: PlanungLookupAbo): PlanningLookupAbo => {
      return new PlanningLookupAbo(
        item.ID,
        item.Nummer,
        item.Titel,
        item.AdressNummer,
        item.AdressLinie,
        `${item.Nummer} / ${item.Titel} / ${item.IhreReferenz}`,
        item.IhreReferenz
      )
    })
  }
}
